{
  "UI Elements": "UI Elements",
  "Forms & Tables": "Forms & Tables",
  "Pages": "Pages",
  "Charts & Maps": "Charts & Maps",
  "Others": "Others",
  "Typography": "Typography",
  "Cards": "Cards",
  "Basic": "Basic",
  "Advance": "Advance",
  "Widgets": "Widgets",
  "Components": "Components",
  "Alert": "Alert",
  "Close Alert": "Close Alert",
  "Avatar": "Avatar",
  "Badge": "Badge",
  "Button": "Button",
  "Calendar": "Calendar",
  "Image": "Image",
  "Pagination": "Pagination",
  "Progress Circular": "Progress Circular",
  "Progress Linear": "Progress Linear",
  "Autocomplete": "Autocomplete",
  "Tooltip": "Tooltip",
  "Slider": "Slider",
  "Date Time Picker": "Date Time Picker",
  "Select": "Select",
  "Switch": "Switch",
  "Checkbox": "Checkbox",
  "Radio": "Radio",
  "Textarea": "Textarea",
  "Rating": "Rating",
  "File Input": "File Input",
  "Otp Input": "Otp Input",
  "Form Layout": "Form Layout",
  "Form Validation": "Form Validation",
  "Charts": "Charts",
  "Apex Chart": "Apex Chart",
  "Chartjs": "Chartjs",
  "Account Settings": "Account Settings",
  "User Profile": "User Profile",
  "FAQ": "FAQ",
  "Dialog Examples": "Dialog Examples",
  "Pricing": "Pricing",
  "List": "List",
  "Edit": "Edit",
  "Nav Levels": "Nav Levels",
  "Level 2.1": "Level 2.1",
  "Level 2.2": "Level 2.2",
  "Level 3.1": "Level 3.1",
  "Level 3.2": "Level 3.2",
  "Raise Support": "Raise Support",
  "Documentation": "Documentation",
  "Dashboards": "Dashboards",
  "Analytics": "Analytics",
  "Apps & Pages": "Apps & Pages",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Invoice",
  "Preview": "Preview",
  "Add": "Add",
  "User": "User",
  "View": "View",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Login": "Login",
  "Register v1": "Register v1",
  "Register v2": "Register v2",
  "Register": "Register",
  "Forget Password v1": "Forget Password v1",
  "Forget Password v2": "Forget Password v2",
  "Forgot Password v1": "Forgot Password v1",
  "Forgot Password v2": "Forgot Password v2",
  "Forgot Password": "Forgot Password",
  "Reset Password v1": "Reset Password v1",
  "Reset Password v2": "Reset Password v2",
  "Reset Password": "Reset Password",
  "Miscellaneous": "Miscellaneous",
  "Coming Soon": "Coming Soon",
  "Not Authorized": "Not Authorized",
  "Under Maintenance": "Under Maintenance",
  "Error": "Error",
  "Statistics": "Statistics",
  "Actions": "Actions",
  "Access Control": "Access Control",
  "User Interface": "User Interface",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Icons",
  "Chip": "Chip",
  "Dialog": "Dialog",
  "Expansion Panel": "Expansion Panel",
  "Combobox": "Combobox",
  "Textfield": "Textfield",
  "Range Slider": "Range Slider",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Tabs",
  "Form Elements": "Form Elements",
  "Form Layouts": "Form Layouts",
  "Authentication": "Authentication",
  "Page Not Found - 404": "Page Not Found - 404",
  "Not Authorized - 401": "Not Authorized - 401",
  "Server Error - 500": "Server Error - 500",
  "2": "2",
  "Forms": "Forms",
  "Timeline": "Timeline",
  "Disabled Menu": "Disabled Menu",
  "Help Center": "Help Center",
  "Verify Email": "Verify Email",
  "Verify Email v1": "Verify Email v1",
  "Verify Email v2": "Verify Email v2",
  "Two Steps": "Two Steps",
  "Two Steps v1": "Two Steps v1",
  "Two Steps v2": "Two Steps v2",
  "Custom Input": "Custom Input",
  "Extensions": "Extensions",
  "Tour": "Tour",
  "Register Multi-Steps": "Register Multi-Steps",
  "Wizard Examples": "Wizard Examples",
  "Checkout": "Checkout",
  "Create Deal": "Create Deal",
  "Property Listing": "Property Listing",
  "Roles & Permissions": "Roles & Permissions",
  "Roles": "Roles",
  "Simple Table": "Simple Table",
  "Tables": "Tables",
  "Data Table": "Data Table",
  "Permissions": "Permissions",
  "Apps": "Apps",
  "Misc": "Misc",
  "Wizard Pages": "Wizard Pages",
  "Form Wizard": "Form Wizard",
  "Numbered": "Numbered",
  "3": "3",
  "ecommerce": "ecommerce",
  "Ecommerce": "Ecommerce",
  "Editors": "Editors",
  "Front Pages": "Front Pages",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Payment",
  "Swiper": "Swiper",
  "Product": "Product",
  "Category": "Category",
  "Order": "Order",
  "Details": "Details",
  "Customer": "Customer",
  "Manage Review": "Manage Review",
  "Referrals": "Referrals",
  "Settings": "Settings",
  "Overview": "Overview",
  "My Course": "My Course",
  "Course Details": "Course Details",
  "Academy": "Academy",
  "Logistics": "Logistics",
  "Dashboard": "Dashboard",
  "Fleet": "Fleet",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "Projects": "Projects",
  "Project": "Project",
  "Sources": "Sources",
  "Site": "Site",
  "IP drug": "IP drug",
  "Sample": "Sample",
  "Template": "Template",
  "Treeview": "Treeview",
  "Html2Pdf": "Html2Pdf",
  "Draggable": "Draggable",
  "Store": "Store",
  "Build": "Build",
  "Subjects": "Subjects",
  "Subject": "Subject",
  "Management": "Management",
  "Schedule": "Schedule",
  "Cycle": "Cycle",
  "Visit": "Visit",
  "CRF Group": "CRF Group",
  "CRF Page": "CRF Page",
  "Standard": "선정 제외 기준",
  "Random": "무작위 배정표",
  "Label": "Label",
  "Desc": "Desc",
  "Data": "Data",
  "Review": "Review",
  "Freezing": "Freezing",
  "Freeze": "Freeze",
  "Locking": "Locking",
  "Data set": "Data set",
  "Document": "Document",
  "Audit Trail": "Audit Trail",
  "Users": "Users",
  "Management Users": "Management Users",
  "Sites": "Sites",
  "Management Sites": "Management Sites",
  "Add Site": "Add Site",
  "loading...": "Loading... Please wait",
  "Type": "Type",
  "Description": "Description",
  "Start Date": "Start Date",
  "Search": "Search",
  "Add Project": "Add Project",
  "Select a project": "Select a project",
  "Project Name": "Project Name",
  "Project No": "Project No",
  "Project Description": "Project Description",
  "Sponsor": "Sponsor",
  "Phase": "Phase",
  "Save": "Save",
  "Cancel": "Cancel",
  "Confirm": "Confirm",
  "Close": "Close",
  "Next": "Next",
  "Site ID": "Site ID",
  "Site Name": "Site Name",
  "Contract date": "Contract date",
  "Phone": "Phone",
  "Address": "Address",
  "Investigator": "Investigator",
  "Investigator team": "Investigator team",
  "Etc": "ETC",
  "Expire": "Expire",
  "User Name": "User Name",
  "End Date": "End Date",
  "Status": "Status",
  "Assignment": "Assignment",
  "Move": "Move to Records Tab",
  "Organization": "Organization",
  "Role": "Role",
  "Add User": "Add User",
  "Edit User": "Edit User",
  "Select Role": "Select Role",
  "Select Site": "Select Site",
  "Subject Name": "Subject Name",
  "Animal Name": "Animal Name",
  "Subject Number": "Subject Number",
  "Species": "Species",
  "Breed": "Breed",
  "Sex": "Sex",
  "Birthday": "Birthday",
  "Add Subject": "Add Subject",
  "History": "History",
  "Restore": "Restore",
  "Subject History": "Subject History",
  "Process": "Process",
  "Reason": "Reason",
  "Creator": "Creator",
  "Date/Time": "Date/Time",
  "eSignature": "eSignature",
  "Restore Subject": "Restore Subject",
  "Delete Subject": "Delete Subject",
  "eSignature_1": "Please check the contents of the following, and then enter the user ID and password in the lower screen.",
  "eSignature_2": "I agree that this content has been accurately described.",
  "eSignature_2_1": "This eSignature has a legal binding force equivalent to the hand-written signature.",
  "eSignature_3": "*To protect your personal information, Please do not save your ID/Password on a public PC",
  "Password": "Password",
  "Date of informed consent": "Date of informed consent",
  "Site Subject Number": "Site Subject Number",
  "Chart No": "Chart No",
  "Age": "Age",
  "Add Visit": "Add Visit",
  "UV": "UV",
  "Enrolled Sites": "Enrolled Sites",
  "Enrolled Subjects": "Enrolled Subjects",
  "Study Notification": "Study Notification",
  "Title": "Title",
  "Contents": "Contents",
  "AttachedFiles": "Attached Files",
  "Written by": "Written by",
  "Date": "Date",
  "File": "File",
  "Adverse Events": "Adverse Events",
  "Unanswered eCRF": "Unanswered eCRF",
  "Visit Label": "Visit Label",
  "CRF group": "CRF group",
  "Monthly Enrollment Status": "Monthly Enrollment Status",
  "$vuetify": {
    "badge": "Badge",
    "noDataText": "No data available",
    "close": "Close",
    "open": "open",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimiter"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Items per page:",
      "itemsPerPageAll": "All",
      "pageText": "{0}-{1} of {2}",
      "firstPage": "First Page",
      "prevPage": "Previous Page",
      "nextPage": "Next Page",
      "lastPage": "Last Page"
    },
    "pagination": {
      "ariaLabel": {
        "root": "root",
        "previous": "previous",
        "next": "next",
        "currentPage": "currentPage",
        "page": "page"
      }
    },
    "input": {
      "clear": "clear",
      "appendAction": "appendAction",
      "prependAction": "prependAction",
      "counterSize": "counterSize",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "counterSize"
    },
    "rating": {
      "ariaLabel": {
        "item": "item"
      }
    },
    "dataIterator": {
      "loadingText": "Loading... Please wait"
    }
  }
}
